// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import ArrowDownRight from 'images/supplier_commodity_picker/arrow-down-right.svg'
import CheckboxSelected from 'images/supplier_commodity_picker/checkbox-selected.svg'
import CheckboxUnchecked from 'images/supplier_commodity_picker/checkbox-unchecked.svg'
import Focusable from './Focusable'

export interface Commodity {
  id: number
  code: string
  item_description: string
}

export interface CommodityClassProps {
  commodity: Commodity
  onSelect: (commodity: Commodity) => void
  isActiveCode: (props: { id: string }) => boolean
  isInActiveCodeHierarchy: (props: { id: string }) => boolean
  setActiveCode: (id: string | null) => void
  checkStatus: string
}

class CommodityClass extends React.Component<CommodityClassProps> {
  commodity = (): Commodity => this.props.commodity
  isSelected = (): boolean => false

  handleSelect = (): void => {
    this.props.onSelect(this.commodity())
  }

  descriptionId = (): string => {
    return `code-${this.commodity().code}-description`
  }

  render (): React.ReactElement {
    return (
      <Focusable
        itemId={this.commodity().id.toString()}
        isActiveItem={this.props.isActiveCode}
        isInActiveItemHierarchy={this.props.isInActiveCodeHierarchy}
        clearFocus={() => this.props.setActiveCode(null)}
      >
        {({ Checkbox, Highlightable }) => {
          return (
            <Highlightable>
              <div
                id={`code-${this.commodity().code}`}
                className='grid-x grid-margin-x commodity align-middle'
                data-testid={`code-${this.commodity().code}`}
              >
                <div className='shrink cell'>
                  <img src={ArrowDownRight} />
                </div>
                <div className='shrink cell'>
                  <Checkbox
                    handleSelect={this.handleSelect} /* eslint-disable-line react/jsx-handler-names */
                    attributes={{
                      'aria-checked': this.props.checkStatus === 'checked',
                      'data-testid': `code-${this.commodity().code}-checkbox`,
                      'aria-labelledby': this.descriptionId()
                    }}
                  >
                    <img src={this.props.checkStatus === 'checked' ? CheckboxSelected : CheckboxUnchecked} />
                  </Checkbox>
                </div>
                <div className='shrink cell'>
                  <div className='code'>CLASS {this.commodity().code}</div>
                </div>
                <div className='auto cell'>
                  {this.commodity().item_description}
                </div>
              </div>
            </Highlightable>
          )
        }}
      </Focusable>
    )
  }
}

(CommodityClass as any).propTypes = {
  commodity: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  checkStatus: PropTypes.string.isRequired,
  setActiveCode: PropTypes.func.isRequired,
  isActiveCode: PropTypes.func.isRequired,
  isInActiveCodeHierarchy: PropTypes.func.isRequired
}

export default CommodityClass
